<template>
  <DateRangePicker
    :value="rangeValue"
    single
    :variant="variant"
    :presets="false"
    :disabled="disabled"
    @input="onInput"
  />
</template>

<script>
import DateRangePicker from './DateRangePicker.vue'

// Thin wrapper around DateRangePicker for single-date inputs (DOB, follow-up
// dates, etc.). Exposes a plain string v-model so callers don't have to
// build a {fromDate, toDate} bridge for each form field.
export default {
  name: 'SingleDatePicker',
  components: { DateRangePicker },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: { type: String, default: '' },
    variant: { type: String, default: 'form' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    rangeValue () {
      // Mirror the date into both ends so the calendar shows the same day
      // selected; single mode skips the to-button anyway.
      return { fromDate: this.value || '', toDate: this.value || '' }
    }
  },
  methods: {
    onInput (range) {
      const next = (range && range.fromDate) || ''
      this.$emit('input', next)
      this.$emit('change', next)
    }
  }
}
</script>
